module.exports = __webpack_public_path__ + "img/jltc.9d4cb1a6.png";